import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useMatch } from 'react-router-dom';
import styles from './ButtonMenubar.module.scss';
function ButtonMenubar({ to, icon, text, notifications, disabled }) {
    const layoutState = useSelector((state) => state.layout);
    const match = useMatch(`${to}/*`);
    const classes = classNames(styles.wrap, { [styles.full]: layoutState.showMenu }, { [styles.active]: match }, { [styles.disabled]: disabled });
    const notificationsBox = () => {
        if (notifications && notifications > 0) {
            return (React.createElement("p", { className: classNames(styles.notifications, {
                    [styles.notificationsFull]: layoutState.showMenu,
                }) }, notifications));
        }
        return null;
    };
    if (!to) {
        return (React.createElement("button", { type: "button", className: classes },
            icon,
            React.createElement("p", { className: styles.text }, text),
            notificationsBox()));
    }
    return (React.createElement(NavLink, { to: to, className: classes },
        icon,
        React.createElement("p", { className: styles.text }, text),
        notificationsBox()));
}
export default ButtonMenubar;
